import defaultTo from 'ramda/es/defaultTo'
import head from 'ramda/es/head'
import prop from 'ramda/es/prop'
import findIndex from 'ramda/es/findIndex'
import pipe from 'ramda/es/pipe'
import always from 'ramda/es/always'

export default class DnDListSortValidator {
    static isAnswerCorrect(answer) {
        const userInput         = answer.userInput()
        const question          = answer.question()
        const expectedAnswers   = question.correctAnswers() // = [{ "?":["x", "y"] }, ...]

        //ca = correct answer
        const findTargetIndex   = (ca,input) => pipe(   always(input),
                                                        head,
                                                        defaultTo({value:[]}),
                                                        prop('value'),
                                                        findIndex(x => x.content===ca) )()
        const mismatch = (ca,i) => findTargetIndex(ca, userInput) !== i

        return !expectedAnswers.some( mismatch )
    }
}